import React, { useState } from 'react';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import {
  Table,
  TableHead,
  Row,
  NormalTableHeader,
  SmallTableHeader,
  TableBody,
  NormalTableCell,
  SmallTableCell,
  Icon,
  ScrollWrapper,
  MyPaginate,
  PaginateButton,
  IconWrapper,
} from './referrerElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';
import useTable from '../../../Hooks/useTable';
import useDeviceDetect from '../../../Hooks/checkDevice';
import Popup from '../../popup/popup';
import EditReferrerPopup from '../../popup/editReferrer';

const ReferrerTable = ({ data, setData, rowsPerPage }) => {
  const axiosPrivate = useAxiosPrivate();
  const { isMobile } = useDeviceDetect();

  const [page, setPage] = useState(1);
  const { slice, range } = useTable(data, page, rowsPerPage);

  const [editOpen, setEditOpen] = useState(false);
  const [selected, setSelected] = useState({});

  const removeReferrer = (id) => {
    const confirmed = window.confirm('Are you sure to remove?');
    if (!confirmed) return;

    axiosPrivate.post(
      '/removeReferrer',
      JSON.stringify({
        id,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status !== 'success') return console.log('Error removing referrer');
      const newData = data.filter((item) => item.ID !== id);
      return setData(newData);
    });
  };

  return (
    <>
      <Popup header="Edit waitlist member" trigger={editOpen} setOpen={setEditOpen}>
        <EditReferrerPopup
          setOpen={setEditOpen}
          trigger={editOpen}
          selected={selected}
          setData={setData}
          data={data}
        />
      </Popup>
      <ScrollWrapper>
        <Table>
          <TableHead>
            <Row>
              <NormalTableHeader>Name</NormalTableHeader>
              <SmallTableHeader>Actions</SmallTableHeader>
            </Row>
          </TableHead>
          <TableBody>
            {slice.map((item, index) => (
              <Row dark={index % 2 === 1} key={item.ID}>
                <NormalTableCell data-label="Name">{item.Name}</NormalTableCell>
                <SmallTableCell>
                  <IconWrapper>
                    <Icon
                      onClick={() => removeReferrer(item.ID)}
                    >
                      <AiFillDelete />
                    </Icon>
                    <Icon
                      edit
                      onClick={() => { setEditOpen(true); setSelected(item); }}
                    >
                      <AiFillEdit />
                    </Icon>
                  </IconWrapper>
                </SmallTableCell>
              </Row>
            ))}
          </TableBody>
        </Table>
      </ScrollWrapper>
      <MyPaginate
        breakLabel={isMobile ? '' : '...'}
        onPageChange={(e) => setPage((e.selected) + 1)}
        pageRangeDisplayed={isMobile ? 1 : 2}
        marginPagesDisplayed={isMobile ? 1 : 2}
        pageCount={range.length}
        renderOnZeroPageCount={null}
        nextLabel={(
          <PaginateButton>
            <MdArrowForward />
          </PaginateButton>
        )}
        previousLabel={(
          <PaginateButton>
            <MdArrowBack />
          </PaginateButton>
        )}
      />
    </>
  );
};

export default ReferrerTable;
